<template>

  <!---------------------------------------------------------Quote Items  ---------------------------------------->
  <div>
    <div class="fixed-grid mx-2 has-1-cols quote-builder-cells-holder"
      :class="{
        // when in multi column view (dropdown view), only have two columns if screen is atleast 1024px or cant see some items
        'has-1-cols': selectedViewType == viewTypes.singleColView || selectedViewType == viewTypes.tabbedView,
        'has-2-cols-desktop': selectedViewType == viewTypes.multiColView}">
      <div class="grid mb-4">
        <!----------- Left hand section labours (RR, Repair, paint) ------------------>
        <div class="cell">

          <div v-if="((selectedTab.type == ItemCategoryTypes.RR || selectedTab.type == ItemCategoryTypes.REP
                 ||selectedTab.type == ItemCategoryTypes.PAINT|| selectedViewType != viewTypes.tabbedView))"
            class="quote-items-section labour mb-4">
            <quote-builder-labour-component :value="value"
              :selected-tab="selectedTab"
              :is-full-width="isFullWidth"
              :view-types="viewTypes"
              :vehicle="vehicle"
              :edit-item-obj="editItemObj"
              :selected-view-type="selectedViewType"
              :next-line-number="nextLineNumberValue"
              :is-audanet="value.isAudaNet || value.isAudaBridge"
              :is-editable="!readOnlyComputed"
              @handleUpdate="newVal => $emit('handleUpdate', newVal)"
              @onOpgCodeChanged="$emit('onOpgCodeChanged')"
              @onItemCopied="onItemCopied"
              @focusNextRow="item => handleFocusNextRow(item)"
              @newItemAdded=" item => newItemAdded(item, true)"
              @handleItemRowClick="handleItemRowClick"
              @itemRowClicked="handleItemRowClick"
              @handlePresentAs="itemId => $emit('handlePresentAs', itemId)"
              @onItemDeleted="lineNum => handleDeletedItemNotification(lineNum)" />
          </div>

          <!-----------------------------Other Labour Component  --------------------------->
          <div v-if="((selectedTab.type == ItemCategoryTypes.MECH || selectedViewType != viewTypes.tabbedView))"
            class="quote-items-section other mb-4">
            <quote-builder-other-labour-component :value="value"
              :selected-tab="selectedTab"
              :is-full-width="isFullWidth"
              :view-types="viewTypes"
              :vehicle="vehicle"
              :edit-item-obj="editItemObj"
              :selected-view-type="selectedViewType"
              :is-audanet="value.isAudaNet || value.isAudaBridge"
              :next-line-number="nextLineNumberValue"
              :is-editable="!readOnlyComputed"
              @handleUpdate="newVal => $emit('handleUpdate', newVal)"
              @onItemCopied="onItemCopied"
              @focusNextRow="item => handleFocusNextRow(item)"
              @newItemAdded=" item => newItemAdded(item, true)"
              @handleItemRowClick="handleItemRowClick"
              @itemRowClicked="handleItemRowClick"
              @handlePresentAs="itemId => $emit('handlePresentAs', itemId)"
              @onItemDeleted="lineNum => handleDeletedItemNotification(lineNum)" />
          </div>

        </div>
        <!----------------- Right hand section parts, etc ------------------------->

        <!----------------------------PARTS ----------------------->
        <div class="cell">
          <div v-if="(selectedTab.type == ItemCategoryTypes.PART || selectedViewType != viewTypes.tabbedView)"
            class="quote-items-section parts mb-4">
            <quote-builder-part-component :value="value"
              :selected-tab="selectedTab"
              :is-full-width="isFullWidth"
              :view-types="viewTypes"
              :edit-item-obj="editItemObj"
              :selected-view-type="selectedViewType"
              :vehicle="vehicle"
              :next-line-number="nextLineNumberValue"
              :is-editable="!readOnlyComputed"
              :is-audanet="value.isAudaNet || value.isAudaBridge"
              @handleUpdate="newVal => $emit('handleUpdate', newVal)"
              @onItemCopied="onItemCopied"
              @focusNextRow="item => handleFocusNextRow(item)"
              @newItemAdded=" item => newItemAdded(item, true)"
              @handleItemRowClick="handleItemRowClick"
              @itemRowClicked="handleItemRowClick"
              @handlePresentAs="itemId => $emit('handlePresentAs', itemId)"
              @onItemDeleted="lineNum => handleDeletedItemNotification(lineNum)" />
          </div>

          <!---------------------- MISC ----------------------->
          <div v-if="(selectedTab.type == ItemCategoryTypes.MISC || selectedViewType != viewTypes.tabbedView)"
            class="quote-items-section misc mb-4">

            <quote-builder-misc-component :value="value"
              :selected-tab="selectedTab"
              :is-full-width="isFullWidth"
              :view-types="viewTypes"
              :edit-item-obj="editItemObj"
              :selected-view-type="selectedViewType"
              :vehicle="vehicle"
              :next-line-number="nextLineNumberValue"
              :is-audanet="value.isAudaNet || value.isAudaBridge"
              :is-editable="!readOnlyComputed"
              @handleUpdate="newVal => $emit('handleUpdate', newVal)"
              @onItemCopied="onItemCopied"
              @focusNextRow="item => handleFocusNextRow(item)"
              @newItemAdded=" item => newItemAdded(item, true)"
              @handleItemRowClick="handleItemRowClick"
              @itemRowClicked="handleItemRowClick"
              @handlePresentAs="itemId => $emit('handlePresentAs', itemId)"
              @onItemDeleted="lineNum => handleDeletedItemNotification(lineNum)" />
          </div>

          <!------------------ SUBL ------------------------>
          <div v-if="(selectedTab.type == ItemCategoryTypes.SUBL || selectedViewType != viewTypes.tabbedView)"
            class="quote-items-section sublets">
            <quote-builder-sublet-component :value="value"
              :selected-tab="selectedTab"
              :is-full-width="isFullWidth"
              :view-types="viewTypes"
              :edit-item-obj="editItemObj"
              :selected-view-type="selectedViewType"
              :vehicle="vehicle"
              :is-audanet="value.isAudaNet || value.isAudaBridge"
              :next-line-number="nextLineNumberValue"
              :is-editable="!readOnlyComputed"
              @handleUpdate="newVal => $emit('handleUpdate', newVal)"
              @onItemCopied="onItemCopied"
              @focusNextRow="item => handleFocusNextRow(item)"
              @newItemAdded=" item => newItemAdded(item, true)"
              @handleItemRowClick="handleItemRowClick"
              @itemRowClicked="handleItemRowClick"
              @handlePresentAs="itemId => $emit('handlePresentAs', itemId)"
              @onItemDeleted="lineNum => handleDeletedItemNotification(lineNum)" />
          </div>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
import QuoteBuilderLabourComponent from './ItemTypeComponents/quoteBuilderLabour/QuoteBuilderLabourComponent.vue'
import QuoteBuilderPartComponent from './ItemTypeComponents/quoteBuilderParts/QuoteBuilderPartComponent.vue'
import QuoteBuilderMiscComponent from './ItemTypeComponents/quoteBuilderMisc/QuoteBuilderMiscComponent.vue'
import QuoteBuilderSubletComponent from './ItemTypeComponents/quoteBuilderSublets/QuoteBuilderSubletComponent.vue'
import QuoteBuilderOtherLabourComponent from './ItemTypeComponents/quoteBuilderOtherLabour/QuoteBuilderOtherLabourComponent.vue'
import { ItemCategoryTypes } from '@/enums'
import { EventHubTypes } from '../../../enums'

export default {
  name: 'QuoteBuilderItemsView',
  components: {
    QuoteBuilderLabourComponent,
    QuoteBuilderPartComponent,
    QuoteBuilderMiscComponent,
    QuoteBuilderSubletComponent,
    QuoteBuilderOtherLabourComponent
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    selectedViewType: {
      type: String,
      required: true
    },
    viewTypes: {
      type: Object,
      required: true
    },
    selectedTab: {
      type: Object,
      required: true
    },
    vehicle: {
      type: Object,
      required: true
    },
    isAvailableItemsOpen: {
      type: Boolean,
      default: false
    },
    avaliableItemsType: {
      type: String,
      default: ''
    },
    isPresentAsModalActive: {
      type: Boolean,
      default: false
    },
    nextLineNumber: {
      type: Number,
      default: 0
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      editItemObj: {
        id: null,
        elementIndex: null
      },

      // delete notification counter
      deleteNotificationCounter: 0,

      // nextLineNumber, set when the component is mounted, then updated when a new item is added
      nextLineNumberValue: 0
    }
  },

  computed: {
    ItemCategoryTypes() {
      return ItemCategoryTypes
    },
    isFullWidth() {
      return !this.isAvailableItemsOpen && (this.selectedViewType === this.viewTypes.singleColView || this.selectedViewType === this.viewTypes.tabbedView)
    },
    readOnlyComputed() {
      return this.value.readOnly || !this.isEditable
    }
  },
  watch: {
    deleteNotificationCounter(newVal) {
      this.handleShowDeleteNotification()
    }
  },
  created() {
  },
  mounted() {
    // listen for click outside of the component
    document.addEventListener('click', this.handleClickOutside)
    window.addEventListener('keydown', this.handleEnterKey)
    this.$eventHub.$on('handleArrowKeyFocus', this.handleArrowKeyFocus)
    this.$eventHub.$on('itemAddedButterfly', this.newItemAdded)

    this.nextLineNumberValue = this.nextLineNumber
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
    window.removeEventListener('keydown', this.handleEnterKey)
    this.$eventHub.$off('handleArrowKeyFocus', this.handleArrowKeyFocus)
    this.$eventHub.$off('itemAddedButterfly', this.newItemAdded)
  },
  methods: {
    handleShowDeleteNotification() {
      if (this.deleteNotificationCounter === 0) return

      // Clear any existing timeout
      if (this.deleteNotificationTimeout) {
        clearTimeout(this.deleteNotificationTimeout)
      }
      // Set a new timeout for debouncing
      this.deleteNotificationTimeout = setTimeout(() => {
        const message = this.deleteNotificationCounter + ' ' + (this.deleteNotificationCounter > 1 ? 'Items' : 'Item') + ' deleted'

        this.$toast.open({
          message: message,
          type: 'is-danger',
          position: 'is-top',
          queue: false,
          duration: 2000
        })

        this.deleteNotificationCounter = 0
      }, 2000) // 2000ms delay before clearing the delete notification
    },

    handleDeletedItemNotification() {
      this.deleteNotificationCounter++
      // decrement nextline number is last added item deleted
      // remove for now
      // if (lineNum + 1 === this.nextLineNumberValue) {
      //   this.nextLineNumberValue--
      // }
    },

    triggerAutoSave() {
      // Emit an event to trigger autosave
      this.$eventHub.$emit(EventHubTypes.AutoSaveQuoteItems)
    },
    newItemAdded(id, focusDesc = false) {
      // increment nextLineNumberValue each time a new item is added
      this.nextLineNumberValue = this.nextLineNumberValue + 1
      this.editItemObj.id = id

      const elementId = id
      // while not found, keep trying to find the element
      const interval = setInterval(() => {
        const element = focusDesc
          ? document.getElementById(elementId + '-itemDesc')
          : document.getElementById(elementId + '-hourValue') ||
            document.getElementById(elementId + '-value') ||
            document.getElementById(elementId + '-itemDesc')
        if (element) {
          clearInterval(interval)

          // Find the index of the element in the list of elements with class 'quote-builder-item-row'
          const elements = document.querySelectorAll('.quote-builder-item-row:not(.strike-through-line):not(.is-hidden)')
          const elementsArray = Array.from(elements)
          const index = elementsArray.findIndex((el) => el.id == elementId)
          this.editItemObj.elementIndex = index

          // if (focusValue) {
          if (element && element.children.length > 0) {
            element.children[0].focus()
          } else if (element) {
            element.focus()
          }
          // }
          // this code is for flashing the element and not focusing on it, in case its needed in the future
          // else {
          //   // Find the closest parent with class 'quote-builder-item-row'
          //   const parentRow = element.closest('.quote-builder-item-row')
          //   if (parentRow) {
          //     console.log('Found parent row:', parentRow)
          //     this.handleFlashItem(parentRow)
          //     // Handle parent row if needed
          //   }
          //   console.log('element', element)
          // }
        }
      }, 100)
    },
    handleFlashItem(element, className = 'flash-highlight') {
      // Find the element

      if (!element) return

      // scroll to the element
      element.scrollIntoView({ behavior: 'smooth', block: 'center' })

      // Add the class
      element.classList.add(className)

      // Remove the class after 1 second
      setTimeout(() => {
        element.classList.remove(className)
      }, 1000)
    },

    handleEnterKey(ev) {
      if (ev.key === 'Tab') {
        if (!this.editItemObj.id) {
          // quote builder item rows (labour, parts, misc, sublet)
          const elements = document.querySelectorAll('.quote-builder-item-row:not(.is-hidden)')
          if (!elements) return
          // Check if any element is already selected
          const selected = elements.values().find((el) => el.classList.contains('is-selected'))
          // if no element is selected, select the first element
          if (!selected) {
            ev.preventDefault()
            const elementId = elements[0].id
            this.editItemObj.id = elementId

            // focus on the first field in the element (description)
            this.$nextTick(() => {
              const element = document.getElementById(elementId + '-itemDesc')
              // If element has a child element, focus on the child element
              if (element && element.children.length > 0) {
                element.children[0].focus()
              } else if (element) {
                element.focus()
              }
            })
          }
        }
      }
    },

    handleFocusNextRow(item) {
      // elements with class quote-builder-item-row and not have strike-through-line & is-hidden
      const elements = document.querySelectorAll('.quote-builder-item-row:not(.strike-through-line):not(.is-hidden)')
      const elementsArray = Array.from(elements)
      const index = elementsArray.findIndex((el) => el.id == item.quoteItemId)

      // current element
      const currentElement = elements[index]

      // if the selected element is the last element, get first element, else get the next element
      const nextElementIndex = index === elements.length - 1 ? 0 : index + 1
      const nextElement = elements[nextElementIndex]

      // check if next element type is different from the current element type
      const prefix = 'type-'

      const classListNextElement = nextElement.className.split(' ')
      let categoryNextElement = ''

      for (const className of classListNextElement) {
        if (className.startsWith(prefix)) {
          categoryNextElement = className.substring(prefix.length)
        }
      }

      const classListCurrentElement = currentElement.className.split(' ')
      let categoryCurrentElement = ''

      for (const className of classListCurrentElement) {
        if (className.startsWith(prefix)) {
          categoryCurrentElement = className.substring(prefix.length)
        }
      }

      // // set a switch case to determine what the next category is
      // const categoryMap = {
      //   RR: 'REP',
      //   REP: 'PAINT',
      //   PAINT: 'mech',
      //   mech: 'part',
      //   part: 'misc',
      //   misc: 'sublet',
      //   sublet: 'RR'
      // }

      // // Get next category or default to 'RR' if not found
      // const nextItemCategory = categoryMap[categoryCurrentElement] || 'RR'

      // if the next element type is different from the current element type
      // or if the next element is empty or if the next element index is smaller than the current element index
      // meaning the tab has looped back to the first element of the same type
      if (
        categoryNextElement !== categoryCurrentElement ||
        !categoryNextElement ||
        (index >= nextElementIndex && categoryNextElement == categoryCurrentElement)
      ) {
        // if the current element is empty (meaning it was just added), delete the element
        // this also means that we are at the end of the category
        if (item.itemDesc == '') {
          if (item.itemType == 'RR' || item.itemType == 'REP' || item.itemType == 'PAINT') {
            this.$eventHub.$emit('deleteLabour', item)
          } else if (item.itemType == 'MECH') {
            this.$eventHub.$emit('deleteOtherLabour', item)
          } else if (item.itemType == 'PART') {
            this.$eventHub.$emit('deletePart', item)
          } else if (item.itemType == 'MISC') {
            this.$eventHub.$emit('deleteMisc', item)
          } else if (item.itemType == 'SUBL') {
            this.$eventHub.$emit('deleteSubletItem', item)
          }

          // this.$nextTick(() => {
          //   // since this is the last item, check if next category is empty,
          //   // we can do so by checking the next element in the elements array (html elements)
          //   // and if the next element is different from the next category, add a blank item of the next category
          //   if (nextItemCategory !== categoryNextElement) {
          //     if (nextItemCategory == 'RR' || nextItemCategory == 'REP' || nextItemCategory == 'PAINT') {
          //       this.$eventHub.$emit('addBlankItemLabour', null, nextItemCategory)
          //     } else if (nextItemCategory == 'mech') {
          //       this.$eventHub.$emit('addBlankItemOtherLabour', null, nextItemCategory)
          //     } else if (nextItemCategory == 'part') {
          //       this.$eventHub.$emit('addBlankItemPart', null, nextItemCategory)
          //     } else if (nextItemCategory == 'misc') {
          //       this.$eventHub.$emit('addBlankItemMisc', null, nextItemCategory)
          //     } else if (nextItemCategory == 'sublet') {
          //       this.$eventHub.$emit('addBlankItemSublet', null, nextItemCategory)
          //     }
          //     return
          //   }
          // })
        }
        // Otherwise, add a blank item of the same category
        else {
          if (item.itemType == 'RR' || item.itemType == 'REP' || item.itemType == 'PAINT') {
            this.$eventHub.$emit('addBlankItemLabour', null, categoryCurrentElement)
          } else if (item.itemType == 'MECH') {
            this.$eventHub.$emit('addBlankItemOtherLabour', null, categoryCurrentElement)
          } else if (item.itemType == 'PART') {
            this.$eventHub.$emit('addBlankItemPart', null, categoryCurrentElement)
          } else if (item.itemType == 'MISC') {
            this.$eventHub.$emit('addBlankItemMisc', null, categoryCurrentElement)
          } else if (item.itemType == 'SUBL') {
            this.$eventHub.$emit('addBlankItemSublet', null, categoryCurrentElement)
          }
          return
        }
      }

      // get the next element id
      const elementId = nextElement.id
      // set the editItemObj id to the next element id
      this.editItemObj.id = elementId

      // focus on the element
      this.$nextTick(() => {
        const element = document.getElementById(elementId + '-itemDesc')
        // If element has a child element, focus on the child element
        if (element && element.children.length > 0) {
          element.children[0].focus()
        } else if (element) {
          element.focus()
        }
      })
    },

    handleArrowKeyFocus(currentIndex, nextElementIndex, fieldId, item, isArrowDown) {
      const elements = document.querySelectorAll('.quote-builder-item-row:not(.strike-through-line):not(.is-hidden)')

      const nextElement = elements[nextElementIndex]
      const currentElement = elements[currentIndex]

      // check if next element type is different from the current element type
      const prefix = 'type-'

      const classListNextElement = nextElement.className.split(' ')
      let categoryNextElement = ''

      for (const className of classListNextElement) {
        if (className.startsWith(prefix)) {
          categoryNextElement = className.substring(prefix.length)
        }
      }

      const classListCurrentElement = currentElement.className.split(' ')
      let categoryCurrentElement = ''

      for (const className of classListCurrentElement) {
        if (className.startsWith(prefix)) {
          categoryCurrentElement = className.substring(prefix.length)
        }
      }

      // const categoryMap = {
      //   RR: 'REP',
      //   REP: 'PAINT',
      //   PAINT: 'mech',
      //   mech: 'part',
      //   part: 'misc',
      //   misc: 'sublet',
      //   sublet: 'RR'
      // }

      // Get next category or default to 'RR' if not found
      // const nextItemCategory = categoryMap[categoryCurrentElement] || 'RR'

      if (
        isArrowDown &&
        (categoryNextElement !== categoryCurrentElement ||
          !categoryNextElement ||
          (currentIndex >= nextElementIndex && categoryNextElement == categoryCurrentElement))
      ) {
        // if the current element is empty (meaning it was just added), delete the element
        if (item.itemDesc == '') {
          if (item.itemType == 'RR' || item.itemType == 'REP' || item.itemType == 'PAINT') {
            this.$eventHub.$emit('deleteLabour', item)
          } else if (item.itemType == 'MECH') {
            this.$eventHub.$emit('deleteOtherLabour', item)
          } else if (item.itemType == 'PART') {
            this.$eventHub.$emit('deletePart', item)
          } else if (item.itemType == 'MISC') {
            this.$eventHub.$emit('deleteMisc', item)
          } else if (item.itemType == 'SUBL') {
            this.$eventHub.$emit('deleteSubletItem', item)
          }

          // this.$nextTick(() => {
          //   // since this is the last item, check if next category is empty,
          //   // we can do so by checking the next element in the elements array (html elements)
          //   // and if the next element is different from the next category, add a blank item of the next category
          //   if (nextItemCategory !== categoryNextElement) {
          //     if (nextItemCategory == 'RR' || nextItemCategory == 'REP' || nextItemCategory == 'PAINT') {
          //       this.$eventHub.$emit('addBlankItemLabour', null, nextItemCategory)
          //     } else if (nextItemCategory == 'mech') {
          //       this.$eventHub.$emit('addBlankItemOtherLabour', null, nextItemCategory)
          //     } else if (nextItemCategory == 'part') {
          //       this.$eventHub.$emit('addBlankItemPart', null, nextItemCategory)
          //     } else if (nextItemCategory == 'misc') {
          //       this.$eventHub.$emit('addBlankItemMisc', null, nextItemCategory)
          //     } else if (nextItemCategory == 'sublet') {
          //       this.$eventHub.$emit('addBlankItemSublet', null, nextItemCategory)
          //     }
          //     return
          //   }
          // })
        }
        // Otherwise, add a blank item
        else {
          if (item.itemType == 'RR' || item.itemType == 'REP' || item.itemType == 'PAINT') {
            this.$eventHub.$emit('addBlankItemLabour', null, categoryCurrentElement)
          } else if (item.itemType == 'MECH') {
            this.$eventHub.$emit('addBlankItemOtherLabour', null, categoryCurrentElement)
          } else if (item.itemType == 'PART') {
            this.$eventHub.$emit('addBlankItemPart', null, categoryCurrentElement)
          } else if (item.itemType == 'MISC') {
            this.$eventHub.$emit('addBlankItemMisc', null, categoryCurrentElement)
          } else if (item.itemType == 'SUBL') {
            this.$eventHub.$emit('addBlankItemSublet', null, categoryCurrentElement)
          }
          return
        }
      }
      this.focusArrowKeyHelper(nextElement, fieldId)
    },
    focusArrowKeyHelper(nextElement, fieldId) {
      this.editItemObj.id = nextElement.id
      this.$nextTick(() => {
        let element = document.getElementById(nextElement.id + '-' + fieldId)
        // if same type of element is not found, try to find, hour, then buy, then value
        if (!element) {
          element =
            document.getElementById(nextElement.id + '-hourValue') ||
            document.getElementById(nextElement.id + '-unit') ||
            document.getElementById(nextElement.id + '-value')
        }
        if (element && element.children.length > 0) {
          element.children[0].focus()
        } else if (element) {
          element.focus()
        }
      })
    },
    handleCreateNewEmptyRow(type) {
      this.$eventHub.$emit('createNewEmptyRow', type)
    },
    handleClickOutside(event) {
      //  if any parent has a parent tbody, return
      if (event.target.closest('tbody')) return

      // if class contains butterfly-item-values, return
      if (event.target.classList.contains('butterfly-item-values')) return

      // if class is button, return
      if (event.target.classList.contains('button') || event.target.classList.contains('butterfly-item-values')) return
      // if modal active, want to save the state before modal was active
      if (this.isPresentAsModalActive) return
      this.editItemObj.id = null
    },

    handleItemRowClick(item, event, close = false) {
      if (close) {
        this.editItemObj.id = null
        return
      }
      // if the item is already selected, return
      if (this.editItemObj.id === item.quoteItemId) return
      this.editItemObj.id = item.quoteItemId
      let elementId = event.target.id
      if (!elementId) elementId = item.quoteItemId + '-itemDesc'
      // add a bit of delay before focusing on the element // not doing this will not focus on the element as it is not rendered yet
      setTimeout(() => {
        const element = document.getElementById(elementId)
        // If element has a child element, focus on the child element
        if (element && element.children.length > 0) {
          element.children[0].focus()
        } else if (element) {
          element.focus()
        }
      }, 75)
    },
    getItemAssessments(item) {
      const itemAssessments = this.itemsAssessments.find((i) => i.quoteItemId === item.quoteItemId)
      if (itemAssessments) {
        return itemAssessments.assessments
      }
      return []
    },
    async getVendors() {
      this.isVendorLoading = true
      const vm = this
      this.initArrays(this.activeItems.length)
      const promises = this.activeItems.map(async function (item, index) {
        const vendorId = item.vendorId || Guid.empty()
        const vendorFilter = {
          id: vendorId,
          name: '',
          pageIndex: 1,
          pageSize: 50
        }
        vm.getVendor(index, vendorFilter)
      })
      await Promise.all(promises)
      this.isVendorLoading = false
    },
    initArrays(length) {
      this.vendors = new Array(length)
      this.vendorFilters = new Array(length)
      this.selectedVendors = new Array(length)
      let size = length
      while (size--) {
        this.vendors.splice(size, 1, null)
        this.vendorFilters.splice(size, 1, null)
        this.selectedVendors.splice(size, 1, null)
      }
    },
    onItemCopied(item) {

      this.nextLineNumberValue = this.nextLineNumberValue + 1

      this.$notification.openNotificationWithType('success', '', 'Item copied to ' + item.itemType)

      this.editItemObj.id = item.quoteItemId
    }
  }
}
</script>

<style lang="scss">
.is-quote-item-field-editable {
  cursor: text;
}

.quote-builder-item-row {
  position: relative;

  &.is-selected {
    z-index: 10;
  }

  &.is-delete-real-item * {
    text-decoration: line-through;
  }

  &.strike-through-line {
    position: relative;
  }

  &.strike-through-line div {
    opacity: 0.9;
  }

  &.strike-through-line::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    border-top: 1px solid rgba($color: #000000, $alpha: 1);
    transform: translateY(-50%);
  }

  &.flash-highlight {
    animation: blueFlash 1s ease-in-out;
  }

  @keyframes blueFlash {
    0% {
      box-shadow: 0 0 0 0 rgba(50, 152, 220, 0);
    }
    50% {
      box-shadow: 0 0 0 4px rgba(50, 152, 220, 0.6); /* Bulma blue color with opacity */
    }
    100% {
      box-shadow: 0 0 0 0 rgba(50, 152, 220, 0);
    }
  }
}

</style>

